<template>
  <div :class="$style.root">
    <div v-if="isReady" :class="$style.result">
      <ResultRow :style="computedAnimateDelay(0)">
        <template #override>
          <div :class="$style.title">成績表</div>
        </template>
      </ResultRow>
      <ResultRow :style="computedAnimateDelay(1)">
        <template #label>
          <SvgIcon
            :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/check.svg')"
            :size="60"
            :class="[$style.svg, $style.correctSvg]"
          />
        </template>
        {{ correctCount }}
      </ResultRow>
      <ResultRow :style="computedAnimateDelay(2)">
        <template #label>
          <SvgIcon
            :svg="require('!svg-inline-loader?classPrefix!@mdi/svg/svg/close.svg')"
            :size="60"
            :class="[$style.svg, $style.wrongSvg]"
          />
        </template>
        {{ wrongCount }}
      </ResultRow>
      <ResultRow :style="computedAnimateDelay(3)">
        <template #label>獲得</template>
        <Coin :n="history.score" appear :size="48" :delay="1600" />
      </ResultRow>
      <ResultRow :style="computedAnimateDelay(4)">
        <template #override>
          <div :class="$style.controls">
            <Link to="/">
              <ExitButton />
            </Link>
          </div>
        </template>
      </ResultRow>
    </div>
    <Loading
      v-if="!isReady"
      :class="$style.loading"
      :size="80"
    />
  </div>
</template>

<script>
import Coin from '@/components/Coin'
import Loading from '@/components/Loading'
import { mapActions } from 'vuex'
import ResultRow from './ResultRow'
import SvgIcon from '@/components/SvgIcon'
import ExitButton from '@/components/ExitButton'
import Link from '@/components/Link'

export default {
  components: {
    Coin,
    Loading,
    ResultRow,
    SvgIcon,
    ExitButton,
    Link,
  },
  props: {
    historyId: {
      type: Number,
    },
  },
  data () {
    return {
      isReady: false,
      history: null,
      questions: [],
    }
  },
  async created () {
    await this.init()
  },
  computed: {
    correctCount () {
      return this.questions.filter(q => q.is_correct).length
    },
    wrongCount () {
      return this.questions.filter(q => !q.is_correct).length
    },
  },
  methods: {
    async init () {
      try {
        const history = await this.getHistory(this.historyId)
        const questions = await this.listQuestion(this.historyId)
        this.history = history
        this.questions = questions
        this.isReady = true
      } catch (e) {
        //
      } finally {
      }
    },
    async getHistory (id) {
      try {
        const { data } = await this.httpGet({
          url: `/history/${id}`
        })
        return data
      } catch (e) {
        //
      }
    },
    async listQuestion (historyId) {
      try {
        const { data } = await this.httpGet({
          url: `/question`,
          query: { history_id: historyId },
        })
        return data
      } catch (e) {
        //
      }
    },
    computedAnimateDelay (index) {
      return {
        'animation-delay': `${index * 200}ms`,
      }
    },
    ...mapActions('http', {
      httpGet: 'get',
      httpPost: 'post',
    }),
  },
}
</script>

<style lang="scss" module>
.root {
  @apply h-full;
  @apply w-full;
  @apply flex;
  @apply items-center;
  @apply justify-center;
}

.result {
  @apply pt-4;
  @apply pb-4;
  @apply px-24;
  @apply rounded-lg;
  background-color: #ffffff4f;
}

.title {
  font-size: 5rem;
  @apply w-full;
  @apply text-center;
}

.svg {
  @apply fill-current;
}

.correctSvg {
  color: #00ff00;
}

.wrongSvg {
  color: #ff0000;
}

.controls {
  @apply flex-grow;
  @apply flex;
  @apply justify-center;
}
</style>
